import type { AuthMePlayer } from '@/app/providers/auth-context'
import { fetchMyBookings } from '@/features/bookings/api'
import { fetchMyLessons } from '@/features/lessons/myLessons'
import { fetchSessionBalances } from '@/features/lessons/useSessionBalances'
import { getMyTournaments } from '@/features/tournaments/partner/api'
import { startRoutePrefetch } from '@/lib/api/routePrefetch'

// ROUTE-ENTRY KICKOFF FOR THE PERSONAL HOME (docs/ux/2026-09-23-home-split.md §4, the
// `/profile` pattern). The eager `/` entry starts the four personal reads during its own
// render, in parallel with the page's lazy chunk; each block's hook takes its promise
// once on mount. Keyed by the viewer, so a read started for one account is never handed
// to another after a sign-out on a shared device.

export type HomeResource = 'bookings' | 'lessons' | 'tournaments' | 'balances'

/** Whose reads these are: the linked player, or one shared slot for an unlinked account. */
export function homeViewer(me: AuthMePlayer | null): string {
  return String(me?.player?.playerId ?? '').trim() || 'self'
}

export function homePrefetchKey(resource: HomeResource, viewer: string): string {
  return `home:${resource}:${viewer}`
}

export function prefetchPersonalHome(viewer: string): void {
  startRoutePrefetch(homePrefetchKey('bookings', viewer), fetchMyBookings)
  startRoutePrefetch(homePrefetchKey('lessons', viewer), fetchMyLessons)
  startRoutePrefetch(homePrefetchKey('tournaments', viewer), getMyTournaments)
  startRoutePrefetch(homePrefetchKey('balances', viewer), fetchSessionBalances)
}
